var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "calendar-list" } },
    [
      _c(
        "div",
        { staticClass: "calendar-actions" },
        [
          _c(
            "div",
            {
              staticClass: "my-calendars-title",
              on: {
                click: function () {
                  return (_vm.calendarListVisible = !_vm.calendarListVisible)
                },
              },
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("calendar.calendars"))),
              ]),
              _vm._v(" "),
              _vm.calendarListVisible
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v("expand_less"),
                  ])
                : _c("span", { staticClass: "material-icons" }, [
                    _vm._v("expand_more"),
                  ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tooltip",
            {
              attrs: {
                placement: "right",
                title: _vm.$t("calendar.newCalendar"),
              },
              on: {
                click: function () {
                  return _vm.openNewCalendarModal()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "20px", cursor: "pointer" },
                },
                [_vm._v("add")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.calendarListVisible
        ? _c(
            "div",
            { staticClass: "my-calendars-list" },
            _vm._l(_vm.calendarUserGroups, function (calendarUserGroup) {
              return _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "user-info",
                      on: {
                        click: function () {
                          return (calendarUserGroup.visible =
                            !calendarUserGroup.visible)
                        },
                      },
                    },
                    [
                      calendarUserGroup.visible
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v("expand_less"),
                          ])
                        : _c("span", { staticClass: "material-icons" }, [
                            _vm._v("expand_more"),
                          ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(calendarUserGroup.userId.name)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.getUserCalendarList(calendarUserGroup.userId._id),
                    function (calendar) {
                      return calendarUserGroup.visible
                        ? _c(
                            "div",
                            { staticClass: "my-calendars-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "box",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "selectCalendar",
                                        calendar
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.isSelected(calendar)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "material-icons checkbox-btn",
                                          style: { color: calendar.color },
                                        },
                                        [
                                          _vm._v(
                                            "\n                        check_box\n                    "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "material-icons checkbox-btn",
                                        },
                                        [_vm._v("check_box_outline_blank")]
                                      ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(calendar.summary)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isPermission(calendar)
                                ? _c(
                                    "a-popover",
                                    {
                                      attrs: {
                                        trigger: "click",
                                        placement: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "a-popover",
                                                  {
                                                    attrs: { trigger: "click" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "content",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    "flex-direction":
                                                                      "row",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a-input",
                                                                    {
                                                                      staticClass:
                                                                        "color-input",
                                                                      attrs: {
                                                                        id: "calendarColor",
                                                                        type: "color",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          calendar.color,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              calendar,
                                                                              "color",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "calendar.color",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "change-color",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.updateCalendarColor(
                                                                              calendar
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                        " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "calendar.change"
                                                                            )
                                                                          ) +
                                                                          "\n                                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "calendar.changeColor"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.isDeletePermission(calendar)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "popover-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteCalendar(
                                                              calendar._id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Sil\n                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "20px",
                                            cursor: "pointer",
                                          },
                                        },
                                        [_vm._v("more_vert")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e()
                    }
                  ),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.newCalendarModalVisible,
            cancelText: _vm.$t("calendar.cancel"),
            okText: _vm.$t("calendar.save"),
            centered: "",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.newCalendarModalVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "add-calendar-title" }, [
              _vm._v(_vm._s(_vm.$t("calendar.addCalendar"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newCalendarSummary,
                  expression: "newCalendarSummary",
                },
              ],
              staticClass: "event-input",
              attrs: {
                type: "text",
                placeholder: _vm.$t("calendar.nameCalendar"),
              },
              domProps: { value: _vm.newCalendarSummary },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newCalendarSummary = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newCalendarDescription,
                  expression: "newCalendarDescription",
                },
              ],
              staticClass: "event-input",
              attrs: {
                type: "text",
                placeholder: _vm.$t("calendar.description"),
              },
              domProps: { value: _vm.newCalendarDescription },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newCalendarDescription = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-action" }, [
            _c(
              "span",
              {
                staticClass: "footer-action-btn",
                on: { click: _vm.closeCreateCalendarModal },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "footer-action-btn",
                on: {
                  click: function ($event) {
                    return _vm.createCalendar()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.save")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }